import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import ExoForm from '../exo/ExoForm';
import Feedback from '../special/Feedback';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import { useEmailClient } from '../email-system/useEmailClient';

export const NewSharedInboxIntegration = ({ onChange, onClose, debug }) => {
  const { t } = useTranslation();
  const config = useConfig();
  const { emailCredentials } = useEmailClient();

  const [isLoading, setIsLoading] = useState(false);
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: '',
  });

  const microsoftCredentials = (emailCredentials?.data || []).filter(
    (c) => c.integrationToken?.type === 'exchange',
  );

  const credentialOptions = microsoftCredentials.map((c) => ({
    label: c.label ? `${c.label} (${c.imapUsername})` : c.imapUsername,
    value: c.id,
  }));

  const fields = [
    {
      label: t('Microsoft Account'),
      key: 'emailCredentialId',
      type: 'customSelect',
      options: credentialOptions,
      noUnselect: true,
    },
    {
      label: t('Label'),
      key: 'label',
      type: 'text',
    },
    {
      label: t('Shared Email Address'),
      key: 'sharedEmail',
      type: 'text',
    },
  ];

  const validationSchema = Yup.object().shape({
    emailCredentialId: Yup.mixed().required(t('Is required')),
    label: Yup.string().required(t('Is required')),
    sharedEmail: Yup.string()
      .email(t('Invalid email'))
      .required(t('Is required')),
  });

  const defaultData = {
    emailCredentialId:
      microsoftCredentials.length === 1 ? microsoftCredentials[0].id : '',
  };

  function handleSubmit(data) {
    const { emailCredentialId, sharedEmail, label } = data;
    DBRequest({
      config,
      path: `email-credentials/${emailCredentialId}/shared-mailboxes`,
      method: API_POST({ sharedEmail, label }),
      onResponse: (res) => {
        onClose();
        onChange && onChange(res);
      },
      onFeedback: (text, type) =>
        setAlertState({ alertOpen: true, alertText: text, alertType: type }),
      onLoading: setIsLoading,
    });
  }

  return (
    <>
      <ExoForm
        debug={debug}
        header={t('Add Shared Mailbox')}
        className="grid grid-cols-1 gap-4"
        fields={fields}
        onSubmit={handleSubmit}
        startDataCollection={defaultData}
        size="small"
        validationSchema={validationSchema}
        noAutoReset
        noDifferences
        onCancel={onClose}
        isLoading={isLoading}
      />
      <Feedback state={alertState} setState={setAlertState} />
    </>
  );
};
